import { api } from './api';

export interface StrikingDistanceItem {
  id: number;
  tenantId: string;
  siteId: number;
  page: string;
  query: string;
  currentPosition: number;
  impressions: number;
  clicks: number;
  ctr: number;
  distanceToPage1: number;
  potentialImpressions: number;
  potentialClicks: number;
  trafficUpliftPct: number;
  opportunityScore: number;
  rankingDifficulty: 'easy' | 'medium' | 'hard';
  dateFrom: string;
  dateTo: string;
  computedAt: string;
}

export interface StrikingDistanceSummary {
  totalOpportunities: number;
  totalPotentialClicks: number;
  avgOpportunityScore: number;
}

export const getStrikingDistance = async (
  siteId: number,
  difficulty?: string,
  limit = 100
): Promise<StrikingDistanceItem[]> => {
  const params = new URLSearchParams();
  params.append('limit', String(limit));
  if (difficulty) params.append('difficulty', difficulty);
  const qs = params.toString();
  const response = await api.get<StrikingDistanceItem[]>(
    `/earlystage/sites/${siteId}/striking-distance${qs ? `?${qs}` : ''}`
  );
  return response.data;
};

export const getStrikingDistanceSummary = async (siteId: number): Promise<StrikingDistanceSummary> => {
  const response = await api.get<StrikingDistanceSummary>(
    `/earlystage/sites/${siteId}/striking-distance/summary`
  );
  return response.data;
};
